import { createSelector } from "@reduxjs/toolkit";
import { compareApi } from "./api/compareApi";

// 1. Input selector
const selectCompareResult = compareApi.endpoints.getCompareList.select();

// 2. Selector for the list of items
export const selectCompareItems = createSelector(
  [selectCompareResult],
  (result) => result.data ?? []
);

// 3. Selector for the count
export const selectCompareCount = createSelector(
  [selectCompareItems],
  (items) => items.length
);

// 4. Selector factory for checking specific item
export const selectIsInCompare = (productId: number) =>
  createSelector([selectCompareItems], (items) => items.includes(productId));
